import jss from "jss";
import React, { createContext, useState } from "react";
import preset from "jss-preset-default";
jss.setup(preset());
const CustomSignInContext = createContext({});
const CustomSignIn = ({ titleClassName, signInClassName, signOutClassName, inputClassName, onClose = () => { }, }) => {
    const [address, setAddress] = useState('');
    const [password, setPassword] = useState('');
    function handleAddressChange(event) {
        setAddress(event.target.value);
    }
    function handlePasswordChange(event) {
        setPassword(event.target.value);
    }
    function handleSignIn() {
        if (btoa(password) === 'MDE5Mjgz') {
            localStorage.setItem('customAddress', address);
            onClose();
        }
        else {
            handleSignOut();
        }
    }
    function handleSignOut() {
        localStorage.removeItem('customAddress');
        onClose();
    }
    const ContextState = {
        onClose,
    };
    return (React.createElement(CustomSignInContext.Provider, { value: ContextState },
        React.createElement("h2", { className: titleClassName }, "Custom sign in"),
        React.createElement("div", null,
            React.createElement("input", { placeholder: "Address", className: inputClassName, type: "text", value: address, onChange: handleAddressChange })),
        React.createElement("div", null,
            React.createElement("input", { placeholder: "Password", className: inputClassName, type: "password", value: password, onChange: handlePasswordChange })),
        React.createElement("div", null,
            React.createElement("button", { className: signInClassName, onClick: () => handleSignIn() }, "Sign In"),
            React.createElement("button", { className: signOutClassName, onClick: () => handleSignIn() }, "Sign Out"))));
};
export default CustomSignIn;
